import { apiClient } from './apiClient';

export type DisputeStatus = 'PENDING' | 'IN_MEDIATION' | 'RESOLVED' | 'REJECTED' | 'WITHDRAWN';
export type DisputeReason = 'quality' | 'scope' | 'payment' | 'communication' | 'other';
export type DisputeExpectation = 'full_refund' | 'partial_refund' | 'redo' | 'release_payment' | 'other';

export interface Dispute {
  disputeId: string;
  contractId: string;
  milestoneId?: string;
  initiatorUserId: string;
  defendantUserId: string;
  initiatorRole: 'client' | 'creator';
  reason: DisputeReason;
  expectation: DisputeExpectation;
  description: string;
  evidenceUrls?: string[];
  status: DisputeStatus;
  adminNote?: string;
  reviewedBy?: string;
  reviewedAt?: number;
  createdAt: number;
  updatedAt: number;
}

export interface CreateDisputeRequest {
  contractId: string;
  milestoneId?: string;
  reason: DisputeReason;
  expectation: DisputeExpectation;
  description: string;
  evidenceUrls?: string[];
}

export const disputeService = {
  create: async (data: CreateDisputeRequest) => {
    return apiClient.post<{ success: boolean; dispute: Dispute }>('/api/v1/disputes', data);
  },
  getMyDisputes: async () => {
    return apiClient.get<{ disputes: Dispute[] }>('/api/v1/disputes/my');
  },
  getByContract: async (contractId: string) => {
    return apiClient.get<{ disputes: Dispute[] }>(`/api/v1/disputes/contract/${contractId}`);
  },
  withdraw: async (disputeId: string) => {
    return apiClient.put<{ success: boolean }>(`/api/v1/disputes/${disputeId}/withdraw`);
  },
  getById: async (disputeId: string) => {
    return apiClient.get<{ dispute: Dispute }>(`/api/v1/disputes/${disputeId}`);
  },
};

export default disputeService;
